"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointerStyles = void 0;
exports.pointerStyles = {
    left: "right",
    "left-top": "right-start",
    "left-bottom": "right-end",
    right: "left",
    "right-top": "left-start",
    "right-bottom": "left-end",
    top: "bottom",
    "top-left": "bottom-start",
    "top-right": "bottom-end",
    "bottom-right": "top-end",
    "bottom-left": "top-start",
    bottom: "top",
};
